import { Breakpoint, CSSObject } from '@mui/material';
import { Record } from 'phosphor-react';

export const breakpoints: Record<Breakpoint, number> = {
  none: 0,
  laptop: 1024,
  xs: 1366,
  sm: 1440,
  md: 1680,
  lg: 1920,
  xl: 2560,
};

export const responsiveStyles = (
  css: Partial<Record<Breakpoint, CSSObject>>
) => {
  return Object.keys(css).reduce((acc, key) => {
    acc[
      `@media only screen and (min-width: ${
        breakpoints[key as keyof typeof breakpoints]
      }px)`
    ] = css[key as keyof typeof css] as CSSObject;
    return acc;
  }, {} as Record<string, CSSObject>);
};
